import React, { lazy, Suspense, useCallback, useMemo, useState } from "react";
import T from "i18n-react";
import { useL } from "@hooks/useDico";
import clsx from "clsx";

const NavDrawerMediaOwners = lazy(() => import("@components/Nav/Drawers/NavDrawerMediaOwners"));
const NavDrawerAgencies = lazy(() => import("@components/Nav/Drawers/NavDrawerAgencies"));
const NavDrawerResources = lazy(() => import("@components/Nav/Drawers/NavDrawerResources"));

export default function DesktopNav() {
	const [activeDrawer, setActiveDrawer] = useState("");
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const l = useL();

	const openDrawer = useCallback((drawerName) => {
		setActiveDrawer(drawerName);
		setIsDrawerOpen(true);
	}, []);

	const closeDrawer = useCallback(() => {
		setIsDrawerOpen(false);
		setActiveDrawer("");
	}, []);

	const topNavSections = useMemo(() => {
		switch (l) {
			case "zh":
				return ["mediaOwners"];
			case "de":
			case "es":
			case "ja":
				return ["mediaOwners", "resources"];
			case "fr":
			case "en":
				return ["mediaOwners", "agencies", "resources"];
			default:
				return [];
		}
	}, [l]);

	return (
		<nav
			className="container main_nav pl-12 hidden md:flex"
			onMouseLeave={() => {
				closeDrawer();
			}}
			onBlur={() => {
				closeDrawer();
			}}>
			{topNavSections.map((section) => (
				<div
					className={clsx("drawer_link", section, { active: activeDrawer === section })}
					key={section}
					onMouseOver={() => {
						openDrawer(section);
					}}
					onFocus={() => {
						openDrawer(section);
					}}
					onClick={() => {
						openDrawer(section);
					}}>
					<span className="label_normal">{section === "resources" ? T.translate("nav.resources") : T.translate(`nav.${section}`)}</span>
					<span className="label_hover font-bold absolute">
						{section === "resources" ? T.translate("nav.resources") : T.translate(`nav.${section}`)}
					</span>
				</div>
			))}
			<div className="spacer"></div>
			<div className={clsx("main_nav__master_drawer rounded-xl shadow-B", { open: isDrawerOpen })}>
				<Suspense fallback={<div />}>
					{["en", "fr", "es", "de", "ja", "zh"].includes(l) && <NavDrawerMediaOwners isActive={activeDrawer === "mediaOwners"} />}
				</Suspense>
				<Suspense fallback={<div />}>{["en", "fr"].includes(l) && <NavDrawerAgencies isActive={activeDrawer === "agencies"} />}</Suspense>
				<Suspense fallback={<div />}>
					{["en", "fr", "es", "de", "ja"].includes(l) && <NavDrawerResources isActive={activeDrawer === "resources"} />}
				</Suspense>
			</div>
		</nav>
	);
}
